// extracted by mini-css-extract-plugin
module.exports = {"portal":"Portal_portal__3VLV_"};